<template>
  <div class="w-100 h-100 position-absolute d-flex">
    <b-card class="m-3 flex-grow-1" no-body>
      <b-row class="h-100" no-gutters>
        <b-col
          class="d-none d-md-flex align-items-center justify-content-center p-3"
          md="6"
        >
          <img :src="loginImg" alt="Image" class="rounded-0 img-fluid" />
        </b-col>
        <b-col class="d-flex align-items-center" md="6">
          <b-card-body>
            <TitleProjectCard></TitleProjectCard>

            <!-- Login Form Step -->
            <LoginForm
              v-if="!showOtpForm && !showForgotPasswordForm"
              ref="loginForm"
              class="mt-4"
              @goHome="goHome"
              @requireOtp="handleRequireOtp"
              @forgotPassword="handleForgotPassword"
            >
            </LoginForm>

            <!-- OTP Form Step -->
            <OtpForm
              v-if="showOtpForm"
              class="mt-4"
              :email="userEmail"
              :password="userPassword"
              @otpVerified="handleOtpVerified"
              @goBack="handleGoBack"
            ></OtpForm>

            <!-- Forgot Password Form Step -->
            <ForgotPasswordForm
              v-if="showForgotPasswordForm"
              class="mt-4"
              @goBack="handleGoBackFromForgotPassword"
            ></ForgotPasswordForm>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import LoginForm from "@/components/login/Login-form.vue";
import OtpForm from "@/components/login/Otp-form.vue";
import ForgotPasswordForm from "@/components/login/Forgot-password-form.vue";
import TitleProjectCard from "@/components/shared/Title-project-card.vue";
import config from "@/plugins/config";
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  create as createItemLocal,
  localStorageKey,
  remove as removeItemLocal,
} from "@/plugins/localStorage/index.js";
import { decrypt as decryptToken } from "@/plugins/JWT/index.js";

export default {
  name: "loginViews",

  data() {
    return {
      loginImg: config.branding.logo,
      showOtpForm: false,
      showForgotPasswordForm: false,
      userEmail: "",
      userPassword: "",
    };
  },

  computed: {
    ...mapGetters(["getHomePath"]),
  },

  components: {
    LoginForm,
    OtpForm,
    ForgotPasswordForm,
    TitleProjectCard,
  },

  methods: {
    ...mapActions(["getUserById", "storePermissions"]),
    ...mapMutations(["modifySession", "modifyPermissions", "modifyRole"]),

    goHome() {
      this.$router.push({ name: this.getHomePath });
    },

    handleRequireOtp(email, password) {
      this.userEmail = email;
      this.userPassword = password;
      this.showOtpForm = true;
    },

    async handleOtpVerified(jwtToken) {
      // Complete the login process with the JWT token
      await this.completeLogin(jwtToken);
      this.showOtpForm = false;
      this.userEmail = "";
    },

    handleGoBack() {
      this.showOtpForm = false;
      this.userEmail = "";
      this.userPassword = "";
    },

    handleForgotPassword() {
      this.showForgotPasswordForm = true;
    },

    handleGoBackFromForgotPassword() {
      this.showForgotPasswordForm = false;
    },

    async completeLogin(jwtToken) {
      let tokenResult = this.generateToken({ data: jwtToken });
      if (tokenResult == null) {
        return;
      }

      this.storeSession(tokenResult);

      let user = await this.getUser(tokenResult);
      if (user == null) {
        return;
      }

      var permisos = this.obtenerPermisosUnicos(user);
      this.storePermissions(permisos);

      this.storeRole(user.roles[0].name);

      this.goHome();
    },

    generateToken(result) {
      createItemLocal(localStorageKey.tokenKey, result.data);

      let tokenResult = decryptToken(result.data);
      if (tokenResult.isError) {
        // Handle error appropriately - you might want to show an alert
        removeItemLocal(localStorageKey.tokenKey);
        return null;
      }

      return tokenResult;
    },

    storeSession(tokenResult) {
      this.modifySession({
        userId: tokenResult.data.UserId,
        username: tokenResult.data.Username,
        mail: tokenResult.data.mail,
        exp: tokenResult.data.exp,
      });
    },

    async getUser(tokenResult) {
      let result = await this.getUserById({ id: tokenResult.data.UserId });

      if (result.isError) {
        // Handle error appropriately - you might want to show an alert
        return null;
      }

      return result.data;
    },

    obtenerPermisosUnicos(usuario) {
      const permisos = new Set();

      usuario.roles.forEach((role) => {
        role.permissions.forEach((permiso) => {
          permisos.add(permiso);
        });
      });

      return Array.from(permisos);
    },

    storePermissions(permisos) {
      let names = permisos.map((x) => {
        return x.name;
      });

      if (names.length === 0) {
        names = ["default-sin-permisos"];
      }

      this.modifyPermissions(names);
      createItemLocal(localStorageKey.permissionKey, names);
    },

    storeRole(role) {
      this.modifyRole(role);
      createItemLocal(localStorageKey.roleKey, role);
    },
  },
};
</script>

<style scoped>
.container-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
